module.exports = __webpack_public_path__ + "static/img/265.ffbf26e0.png";